module.exports = __webpack_public_path__ + "static/media/atlas.2289a981.svg";